/**
 * Theme Components Export
 * 
 * Centralized export for theme-related components and CSS variables system
 */

export { default as ThemeToggle } from './ThemeToggle';
export { default as ThemeSelector } from './ThemeSelector';
export { default as TrendColorSchemeSelector } from './TrendColorSchemeSelector';

// Re-export theme utilities for convenience
export {
  convertThemeToCSSVariables,
  applyCSSVariablesToRoot,
  injectThemeTransitionStyles,
  performanceMonitor,
} from '../../utils/cssVariables';

// Re-export theme context
export { useThemeMode, CustomThemeProvider } from '../../contexts/ThemeContext';

// Re-export predefined themes
export { previewThemes } from '../../themes/previewThemes';